import { Container, ContainerManager } from "statuo";

import { get as getPageOptions } from "../utilities/options";

//import CoursesFilterContext from './models/Courses';
//import TeetimesFilterContext from './models/Teetimes';
import GeneralFilterContext from "./models/General";

/* ========================================================================== */

export default new ContainerManager(
  {
    general: GeneralFilterContext,
    empty: Container,
  },
  () => getPageOptions("filter-context") || "empty",
);
